module.exports = __webpack_public_path__ + "static/media/icon_gaoxiao.46006613.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/compliance/icon_gaoxiao.svg
// module id = 502
// module chunks = 0